import {
  ICreateManagement,
  ILoadManagement,
  IManagementProps,
  IUpdateManagement,
  RemoveAnimalByManagement,
} from "../../modules/management/interfaces";
import { api } from "../api";

const getManagements = async ({
  id_user,
  id_farm,
  fromDate,
  toDate,
  page,
  limit,
}: ILoadManagement) => {
  const { data } = await api.get(
    `/management/search/user?id_user=${id_user}&id_farm=${id_farm}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`
  );

  return data;
};

const getAllManagements = async ({
  id_user,
  id_farm,
  fromDate,
  toDate,
}: ILoadManagement) => {
  const managements: IManagementProps[] = [];
  const page = 1;
  const limit = 10;

  const url = `/management/search/user?id_user=${id_user}&id_farm=${id_farm}&fromDate=${fromDate}&toDate=${toDate}`;

  const { data } = await api.get(`${url}&page=${page}&limit=${limit}`);

  managements.push(...data.data);

  if (data.meta.pages > 1) {
    for (let index = page + 1; index <= data.meta.pages; index++) {
      const { data } = await api.get(`${url}&page=${page}&limit=${limit}`);
      managements.push(...data.data);
    }
  }

  return managements;
};

const updateManagement = async ({ id, data }: IUpdateManagement) => {
  await api.put(`/management/${id}`, {
    attributes: {
      animals: data,
    },
  });
};

const getManagementById = async (id: string) => {
  const { data } = await api.get(`/management/${id}`);

  return data;
};

const createManagement = async (data: ICreateManagement) => {
  return await api.post("/management", data);
};

const removeAnimalByManagement = async ({
  idAnimal,
  idManagement,
}: RemoveAnimalByManagement) => {
  await api.delete(
    `/management/remove/animal?idAnimal=${idAnimal}&idManagement=${idManagement}`
  );
};

export {
  getManagementById,
  getManagements,
  createManagement,
  getAllManagements,
  updateManagement,
  removeAnimalByManagement,
};
